<template>
  <div>
    <v-btn class="ma-2" outlined color="green" to="/">Back</v-btn>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>